import React, { Component } from 'react';
import { Grid, GridCell, Button } from 'rmwc';
import { Card, CardPrimary, CardTitle, CardSupportingText, CardActions, CardAction } from 'rmwc/Card';
import { Text } from '../../components/Text';

export const ActionWrapper = ({ children, helperText, onContinue, canContinue, onBack }) => {
  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Text
        style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        className="hrbr-form pb-3"
      >
        {children}
      </Text>
      {helperText && <CardActions className="pl-3">{helperText}</CardActions>}
      <CardActions className="p-3">
        <CardAction theme="secondary" onClick={onBack}>
          Back
        </CardAction>
        <CardAction
          theme={canContinue ? 'secondary-bg on-secondary' : null}
          unelevated
          disabled={!canContinue}
          onClick={onContinue}
        >
          Continue
        </CardAction>
      </CardActions>
    </div>
  );
};
